module.exports = __webpack_public_path__ + "c6edf2480a3fde945bb28ea764bda12e.pdf";